import React, {memo, Suspense} from "react"
import {formatTextTestIds} from "@next/utils"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {TextModel} from "../../../../models/Text"
import env from "../../../../config/env"
import {Filter} from "../../../../models/Filter"
import connect from "./connect"
import ChevronImage from "../chevronImage"

export interface FacetListClearAllButtonProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    text: TextModel
    filter: Filter
    filterName: string
    clearTypeFilters: (displayName: string, filterName: string) => void
    filterOpen: boolean
}

const FacetListClearAllButton = memo(
    ({templating, text, filter, clearTypeFilters, filterOpen, filterName}: FacetListClearAllButtonProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        const getTestIdForElement = (elementName: string) =>
            formatTextTestIds(`plp-filter-${elementName}-${filterName}`)

        return (
            <Suspense>
                <ComponentName
                    onClick={() => clearTypeFilters(filter.displayName, filter.name)}
                    endIcon={
                        <ChevronImage
                            $isFilterOpen={filterOpen}
                            src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/shared/close.svg`}
                            alt="close"
                            dataTestId={getTestIdForElement("clear-all-chevron")}
                        />
                    }
                    data-testid={getTestIdForElement("clear-all-button")}
                    disableRipple
                    disableFocusRipple
                >
                    {text.labels.clearText}
                </ComponentName>
            </Suspense>
        )
    },
)
FacetListClearAllButton.displayName = "FacetListClearAllButton"

export default connect(FacetListClearAllButton)
